module.exports = __webpack_public_path__ + "e0106718/img/trash-icon.ff8201c7.svg";